// extracted by mini-css-extract-plugin
export default {"home":"Home-page_home__m6hDv","slogan":"Home-page_slogan__EgrwV","green":"Home-page_green__DD5Tq","long":"Home-page_long__YZTHw"};